import { Dispatch } from "redux";
import Constants from "../../core/libraries/Constants";
import { setDocumentTypes, callbackUploadReport, setROUList, setLLDivisionAdmin, setGMList } from "./actions";
import { IUserProfile } from "../Auth/types";
import { getDocumentTypes, uploadReport } from "./services";
import { IGetOrgInfoReq, Organization } from "../../services/type";
import { getSuperiorDeps, getDirectDeps } from "../../services/idmServices";
import { getLLDivisionAdmin } from "../../services/aadServices";

export const getDocumentTypesDispatch = (uploadType: string) => async (dispatch: Dispatch) => {
    if (uploadType !== Constants.UPLOAD_TYPE.LL) {
        let data = await getDocumentTypes(uploadType);
        dispatch(setDocumentTypes(uploadType, data));
    }
};

export const getSuperiorDepsDispatch = (request: IGetOrgInfoReq, userProfile: IUserProfile, callback: (list: Organization[]) => void, includeDeputy: boolean = false) => async (dispatch: Dispatch) => {
    let rouLists = await getSuperiorDeps(request,includeDeputy);
    !!rouLists && dispatch(setROUList(rouLists, userProfile, false, callback));
}

export const getDirectManagerDispatch = (request: IGetOrgInfoReq, userProfile: IUserProfile, callback: (list: Organization[]) => void, includeDeputy: boolean = false) => async (dispatch: Dispatch) => {
    let gmLists = await getDirectDeps(request, includeDeputy);
    !!gmLists && dispatch(setGMList(gmLists, userProfile, false, callback));
}


export const loadLLDivisionAdmin = (division: string, callback: () => void) => async (dispatch: Dispatch) => {
    let llAdmin = await getLLDivisionAdmin(division)
    !!llAdmin && dispatch(setLLDivisionAdmin(llAdmin, callback));
}

export const uploadReportDispatch = (report: any, mode: string, callback: any) => async (dispatch: Dispatch) => {
    let uploadResult = await uploadReport(report, mode);
    dispatch(callbackUploadReport(uploadResult, callback));
};
